import React, { useEffect, useState } from "react";
import { getAutoCountries } from '../../Services/API';
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { RaiseForexEnquiry } from '../../Services/EnquiryApi'

const ForexSearch = () => {

  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState("");
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [enquiryMessage, setEnquiryMessage] = useState("");
  const [enquiryStatus, setEnquiryStatus] = useState(false);
  // Date UI display states
  // const [dayNum, setDayNum] = useState("08");
  // const [monthYear, setMonthYear] = useState("Oct-2025");
  // const [dayName, setDayName] = useState("Friday");

  const today = new Date();

  const formattedDay = ("0" + today.getDate()).slice(-2);
  const formattedMonth = today.toLocaleString("default", { month: "short" });
  const formattedYear = today.getFullYear();
  const formattedDayName = today.toLocaleDateString("default", { weekday: "long" });

  const [dayNum, setDayNum] = useState(formattedDay);
  const [monthYear, setMonthYear] = useState(`${formattedMonth}-${formattedYear}`);
  const [dayName, setDayName] = useState(formattedDayName);

  // Load countries
  useEffect(() => {
    const fetchCountries = async () => {
      const data = await getAutoCountries();
      const list = Array.isArray(data?.countries) ? data.countries : [];
      setCountries(list);

      const india = list.find(c => c.countryCode?.toLowerCase() === "in");
      if (india) setSelectedCountry(india.countryCode);
    };
    fetchCountries();
  }, []);

  // jQuery Datepicker
  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd/mm/yy",   // <-- REQUIRED FORMAT
      appendTo: "#dateDisplay",
      minDate: 0,
      showAnim: "fadeIn",

      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },

      onSelect: function (selectedDate) {
        setDate(selectedDate);   // <-- Save date to state

        const dateObj = $(this).datepicker("getDate");
        const day = ("0" + dateObj.getDate()).slice(-2);
        const month = dateObj.toLocaleString("default", { month: "short" });
        const year = dateObj.getFullYear();
        const weekday = dateObj.toLocaleDateString("default", { weekday: "long" });

        setDayNum(day);
        setMonthYear(`${month}-${year}`);
        setDayName(weekday);
      },
    });
  }, []);

  // Currency list
  const [selectedCurrency, setSelectedCurrency] = useState("INR");

  const currencyList = [
    { code: "USD", name: "US Dollar", symbol: "$" },
    { code: "EUR", name: "Euro", symbol: "€" },
    { code: "GBP", name: "British Pound", symbol: "£" },
    { code: "INR", name: "Indian Rupee", symbol: "₹" },
    { code: "AED", name: "UAE Dirham", symbol: "د.إ" },
    { code: "AUD", name: "Australian Dollar", symbol: "A$" },
    { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
    { code: "CHF", name: "Swiss Franc", symbol: "Fr" },
    { code: "CNY", name: "Chinese Yuan", symbol: "¥" },
    { code: "JPY", name: "Japanese Yen", symbol: "¥" },
    { code: "SGD", name: "Singapore Dollar", symbol: "S$" },
    { code: "HKD", name: "Hong Kong Dollar", symbol: "HK$" },
    { code: "NZD", name: "New Zealand Dollar", symbol: "NZ$" },
    { code: "SAR", name: "Saudi Riyal", symbol: "﷼" },
    { code: "THB", name: "Thai Baht", symbol: "฿" },
    { code: "ZAR", name: "South African Rand", symbol: "R" },
    { code: "SEK", name: "Swedish Krona", symbol: "kr" },
    { code: "NOK", name: "Norwegian Krone", symbol: "kr" },
    { code: "DKK", name: "Danish Krone", symbol: "kr" },
    { code: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
    { code: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
    { code: "KRW", name: "South Korean Won", symbol: "₩" },
    { code: "PHP", name: "Philippine Peso", symbol: "₱" },
    { code: "PKR", name: "Pakistani Rupee", symbol: "₨" },
    { code: "LKR", name: "Sri Lankan Rupee", symbol: "Rs" },
    { code: "BDT", name: "Bangladeshi Taka", symbol: "৳" },
    { code: "TRY", name: "Turkish Lira", symbol: "₺" },
    { code: "RUB", name: "Russian Ruble", symbol: "₽" },
    { code: "ILS", name: "Israeli Shekel", symbol: "₪" },
    { code: "EGP", name: "Egyptian Pound", symbol: "£" },
    { code: "NGN", name: "Nigerian Naira", symbol: "₦" },
    { code: "KES", name: "Kenyan Shilling", symbol: "KSh" },
    { code: "BHD", name: "Bahraini Dinar", symbol: ".د.ب" },
    { code: "OMR", name: "Omani Rial", symbol: "﷼" },
    { code: "QAR", name: "Qatari Riyal", symbol: "﷼" },
    { code: "KWD", name: "Kuwaiti Dinar", symbol: "د.ك" },
    { code: "VND", name: "Vietnamese Dong", symbol: "₫" },
    { code: "MXN", name: "Mexican Peso", symbol: "$" },
    { code: "BRL", name: "Brazilian Real", symbol: "R$" },
    { code: "ARS", name: "Argentine Peso", symbol: "$" },
    { code: "CLP", name: "Chilean Peso", symbol: "$" },
  ];

  // Submit request
  const handleRaiseRequest = async () => {
    let newErrors = {};

    if (!selectedCountry.trim()) {
      newErrors.country = "Please select a Country";
    }

    // DATE VALIDATION
    if (!date.trim()) {
      newErrors.date = "Please select Trip Start Date";
    } else {
      const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
      if (!datePattern.test(date)) {
        newErrors.date = "Date must be in dd/mm/yyyy format";
      }
    }

    if (!amount.trim()) {
      newErrors.amount = "Please enter Amount";
    }

    if (!selectedCurrency.trim()) {
      newErrors.currency = "Please select a Currency";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    const requestBody = {
      TravelType: "",
      TravelCountry: selectedCountry,
      TripStartDate: date,
      amount: amount,
      Currency: selectedCurrency,
      CompanyId: "B2343",
      CreatedBy: "BerryJourneys"
    };

    try {
      const result = await RaiseForexEnquiry(requestBody);
      if (result.success) {
        setEnquiryMessage(result.message)
        setEnquiryStatus(true);
      }
      else {
        setEnquiryMessage(result.message)
      }
      setShowPopup(true);
    } catch {
      alert("Failed to submit enquiry");
    }
  };

  return (
    <>
      <div className='forex_serch'>
        <div className='row'>
          <div className='col-md-6 col-lg-6'>
            <div className='d-flex'>
              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="BusinessTravel" id="BusinessTravel" />
                  <label className="form-check-label" htmlFor="BusinessTravel">Business Travel</label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="PersonalTravel" id="PersonalTravel" />
                  <label className="form-check-label" htmlFor="PersonalTravel">Personal Travel</label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input className="form-check-input" type="radio" name="travelType" value="GuestTravel" id="GuestTravel" />
                  <label className="form-check-label" htmlFor="GuestTravel">Guest Travel</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FORM */}
        <div className="form_ful">
          <div className="forex_trade">

            {/* Country */}
            <div className="forec_col_1 Country">
              <label><i className="fa fa-location-dot"></i> Travel Country</label>

              <select className="select_date" value={selectedCountry} onChange={(e) => setSelectedCountry(e.target.value)}>
                <option value="">Country</option>
                {countries.map((country, idx) => (
                  <option key={idx} value={country.countryCode}>
                    {country.countryName}
                  </option>
                ))}
              </select>
              {errors.country && <p className="error_mes">{errors.country}</p>}
            </div>

            {/* Date */}
            <div className='forec_col_1'>
              <label><i className="fa fa-calendar-days"></i> Trip Start Date</label>

              <div
                className="travl_from_visa"
                id="dateDisplay"
                onClick={() => $("#departureDate").datepicker("show")}
              >
                <span id="dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}>{dayNum}</span>{" "}
                <span id="monthYear" style={{ fontSize: "14px" }}>{monthYear}</span>
                <br />
                <span id="dayName">{dayName}</span>

                <input type="text" id="departureDate" style={{ position: "absolute", left: "-9999px" }} />
              </div>
              {errors.date && <p className="error_mes">{errors.date}</p>}
            </div>

            {/* Amount */}
            <div className="forec_col_1">
              <label><i className="fa fa-indian-rupee-sign"></i> Amount</label>
              <input
                className="form_contrl_Amount"
                placeholder="Amount"
                value={amount}
                type="number"
                onChange={(e) => setAmount(e.target.value)}
              />
              {errors.amount && <p className="error_mes">{errors.amount}</p>}
            </div>

            {/* Currency */}
            <div className="forec_col_1 Country_cr">
              <label><i className="fa fa-coins"></i> Currency</label>
              <select className="forex_curncy" value={selectedCurrency} onChange={(e) => setSelectedCurrency(e.target.value)}>
                {currencyList.map(curr => (
                  <option key={curr.code} value={curr.code}>
                    {curr.symbol} {curr.code} — {curr.name}
                  </option>
                ))}
              </select>
              {errors.currency && <p className="error_mes">{errors.currency}</p>}
            </div>

            {/* Submit Button */}
            <div className="Rooms_Guests_Serch">
              <button className="Serch" onClick={handleRaiseRequest} type="button">
                Raise Request
              </button>
            </div>

          </div>
        </div>

      </div>

      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3>{enquiryMessage}</h3>
            <button
              onClick={() => {
                setShowPopup(false);
                window.location.reload();
              }}
              className="btn btn-primary"
            >
              Ok
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ForexSearch;
